/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CurrentGuestUpdateRequest,
  PutApiCurrentGuestUpdate200,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type putApiCurrentGuestUpdateResponse200 = {
  data: PutApiCurrentGuestUpdate200
  status: 200
}

export type putApiCurrentGuestUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiCurrentGuestUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiCurrentGuestUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiCurrentGuestUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiCurrentGuestUpdateResponseSuccess = (putApiCurrentGuestUpdateResponse200) & {
  headers: Headers;
};
export type putApiCurrentGuestUpdateResponseError = (putApiCurrentGuestUpdateResponse400 | putApiCurrentGuestUpdateResponse401 | putApiCurrentGuestUpdateResponse403 | putApiCurrentGuestUpdateResponse409) & {
  headers: Headers;
};

export type putApiCurrentGuestUpdateResponse = (putApiCurrentGuestUpdateResponseSuccess | putApiCurrentGuestUpdateResponseError)

export const getPutApiCurrentGuestUpdateUrl = () => {


  

  return `/api/guest`
}

export const putApiCurrentGuestUpdate = async (currentGuestUpdateRequest: CurrentGuestUpdateRequest, options?: RequestInit): Promise<putApiCurrentGuestUpdateResponse> => {
  
  return customFetch<putApiCurrentGuestUpdateResponse>(getPutApiCurrentGuestUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      currentGuestUpdateRequest,)
  }
);}


